<template>
  <div>
    <base-header class="pb-8 pt-4">
    </base-header>

    <div class="container-fluid mt--7">
      <b-card class="mb-4">
        <b-tabs v-model="tab" pills card vertical class="custom-tabs">
          <b-tab title="Firma Bilgileri" active>
            <template v-if="tab === 0">
              <company-settings />
            </template>
          </b-tab>
          <b-tab title="Kullanıcılar">
            <template v-if="tab === 1">
              <users />
            </template>
          </b-tab>
        </b-tabs>
      </b-card>
    </div>
  </div>
</template>

<script>
  import CompanySettings from "./components/CompanySettings";
  import Users from "./components/Users";

  export default {
    name: "CompanyDetail",
    components: {
      CompanySettings,
      Users,
    },
    data() {
      return {
        tab: 0,
      };
    },
  };
</script>
